import { render, staticRenderFns } from "./MergeManagement.vue?vue&type=template&id=2f8bff5c&scoped=true"
import script from "./MergeManagement.vue?vue&type=script&lang=js"
export * from "./MergeManagement.vue?vue&type=script&lang=js"
import style0 from "./MergeManagement.vue?vue&type=style&index=0&id=2f8bff5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8bff5c",
  null
  
)

export default component.exports